import Mock from "../mock";

const database = {
  information: {
    name: "Carrick Taehong Park",
    aboutContent:
      "Web Developer specializing in modern web applications, React, JavaScript, API integrations, and CMS/e-commerce solutions including WordPress and Shopify. I build clean, maintainable, and user-focused digital experiences that help businesses grow.",
    //age: 34,
    phone: "0430 542 144",
    // nationality: 'American',
    language: "English, Korean",
    email: "univerpark@naver.com",
    address: "Castle Hill, NSW 2154",
    // freelanceStatus: 'Available',
    socialLinks: {
      facebook: "https://facebook.com",
      twitter: "https://twitter.com",
      pinterest: "",
      behance: "",
      linkedin: "",
      dribbble: "",
      github: "https://github.com",
    },
    // brandImage: "/images/brand-image.jpg",
    // aboutImage: "/images/about-image.jpg",
    brandImage: "/images/p1.jpg",
    aboutImage: "/images/p1.jpg",
    aboutImageLg: "/images/about-image-lg.jpg",
    cvfile: "/files/Resume CarrickPark.pdf",
  },
  services: [
    // {
    //   title: "Web Design",
    //   icon: "color-pallet",
    //   details:
    //     "Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem tenetur ratione quod.",
    // },
    {
      title: "Front-End Development",
      icon: "code",
      details:
        "I specialize in developing web applications using JavaScript and ReactJS. Additionally, I have extensive experience working with WordPress and PHP. I am proficient in SCSS and Bootstrap, enabling me to create responsive and visually appealing user interfaces.",
    },
    {
      title: "Back-End Development",
      icon: "mouse",
      details:
        "I have an experience in designing and implementing robust, scalable, and efficient server-side applications. My expertise spans across Java and Node.js for backend development, along with a strong proficiency in Linux for server management and deployment.",
    },
    {
      title: "API Development",
      icon: "code",
      details:
        "Skilled in designing and implementing RESTful APIs, ensuring seamless communication between client and server applications.",
    },
    {
      title: "DevOps",
      icon: "mouse",
      details:
        "Familiar with CI/CD pipelines and containerization technologies like ASW and Git, facilitating streamlined development and deployment processes.",
    },
  ],
  references: [
    {
      name: "Silvana Habib",
      title: "7th Avenue Business owner",
      contact: "0415 180 066",
      email: "silvanahabib22@icloud.com",
    },
    {
      name: "Ji eun Lee",
      title: "Elshuo Business owner",
      contact: "0413 685 948",
      email: "admin@elshuo.com.au",
    },
  ],
  reviews: [
    {
      id: 1,
      content:
        "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Expedita impedit nobis tempore quaerat quibusdam, aliquid maxime tempora.",
      author: {
        name: "Burdette Turner",
        designation: "Web Developer, Abc Company",
      },
    },
    {
      id: 2,
      content:
        "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Expedita impedit nobis tempore quaerat quibusdam.",
      author: {
        name: "Susan Yost",
        designation: "Client",
      },
    },
    {
      id: 3,
      content: "Lorem ipsum dolor, sit amet consectetur adipisicing elit.",
      author: {
        name: "Irving Feeney",
        designation: "Fiverr Client",
      },
    },
  ],
  skills: [
    {
      title: "Frontend",
      items: [
        "JavaScript (ES6+)",
        "React.js",
        "HTML5",
        "CSS3/SCSS",
        "Bootstrap",
        "jQuery",
      ],
    },
    {
      title: "Backend & APIs",
      items: ["Node.js (Express)", "PHP", "RESTful APIs"],
    },
    {
      title: "Tools & Platforms",
      items: ["GitHub (Version Control)", "WordPress", "Shopify"],
    },
    {
      title: "Systems & Infrastructures",
      items: ["Linux (RHEL)", "Windows Server"],
    },
  ],
  portfolios: [
    {
      id: 6,
      title: "Elshuo Cat Care",
      subtitle:
        "ReactJS, Firebase, AWS | Commercial cat-sitting web app featuring Firebase real-time chat and deployed on AWS.",
      imageUrl: "/images/e1.jpg",
      largeImageUrl: ["/images/e1.jpg", "/images/e2.jpg", "/images/e3.jpg"],
      url: "https://elshuo.com.au",
    },
    {
      id: 1,
      title: "Mt Annan Christian School",
      subtitle:
        "JavaScript, WordPress, PHP | Built a modern, trend-focused UI by precisely translating Figma designs. Customized Google Maps API with bespoke markers.",
      imageUrl: "/images/macc1.png",
      largeImageUrl: ["/images/macc1.png", "/images/macc2.jpeg", "/images/macc3.jpeg"],
      url: "https://macc.nsw.edu.au",
    },
    {
      id: 2,
      title: "Balmain District Football Club",
      subtitle:
        "JavaScript, WordPress, PHP | Developed a modern, high-performance interface based on Figma design systems, featuring clean and trendy UI layouts.",
      imageUrl: "/images/bdfc1.png",
      largeImageUrl: ["/images/bdfc1.png", "/images/bdfc2.png", "/images/bdfc3.png"],
      url: "https://balmainfootball.com.au/",
    },
    {
      id: 3,
      title: "Scripture Union",
      subtitle:
        "JavaScript, WordPress, PHP | Implemented data synchronization between WordPress and Salesforce CRM. Customized Google Maps API with custom map markers.",
      imageUrl: "/images/su1.png",
      largeImageUrl: ["/images/su1.png", "/images/su2.png", "/images/su3.png"],
      url: "https://sunsw.org.au",
    },
    {
      id: 5,
      title: "Meet Jesus",
      subtitle:
        "JavaScript, WordPress, PHP | Implemented user authentication flow (login/logout features) utilizing browser LocalStorage.",
      imageUrl: "/images/meetJesus1.png",
      largeImageUrl: ["/images/meetJesus1.png", "/images/meetJesus2.png", "/images/meetJesus3.png"],
      url: "https://meetjesus.au/",
    },
    {
      id: 7,
      title: "Hey Lemonade",
      subtitle:
        "JavaScript, WordPress, PHP | Developed a responsive web platform integrated and linked with a mobile application.",
      imageUrl: "/images/hl1.png",
      largeImageUrl: ["/images/hl1.png", "/images/hl2.png", "/images/hl3.png"],
      url: "https://heylemonade.com.au/",
    },
    {
      id: 8,
      title: "IJM Singapore",
      subtitle:
        "JavaScript, WordPress, PHP | Developed and maintained the official regional web platform for an international NGO.",
      imageUrl: "/images/ijmsg1.png",
      largeImageUrl: ["/images/ijmsg1.png", "/images/ijmsg2.png", "/images/ijmsg3.png"],
      url: "https://ijmsg.org/",
    },
    {
      id: 9,
      title: "Artmar",
      subtitle:
        "JavaScript, WordPress, PHP | Developed an e-commerce and product showcase website for a premium tile company.",
      imageUrl: "/images/artmar1.png",
      largeImageUrl: ["/images/artmar1.png", "/images/artmar2.png", "/images/artmar2.png"],
      url: "https://artmar.com.au/",
    },
    {
      id: 16,
      title: "Saigon Fabrics",
      subtitle:
        "JavaScript, WordPress, PHP | Developed a custom retail 'Wishlist' feature utilizing client-side LocalStorage.",
      imageUrl: "/images/saigon1.png",
      largeImageUrl: ["/images/saigon1.png", "/images/saigon2.png", "/images/saigon3.png"],
      url: "https://www.saigonfabrics.com.au/",
    },
    {
      id: 4,
      title: "NTE",
      subtitle:
        "JavaScript, WordPress, PHP | Built a modular core framework that enables seamless annual layout updates and design overhauls since 2021.",
      imageUrl: "/images/nte1.png",
      largeImageUrl: ["/images/nte1.png", "/images/nte2.png", "/images/nte3.png"],
      url: "https://nte.org.au/",
    },
    {
      id: 15,
      title: "IJM HONG KONG",
      subtitle:
        "JavaScript, WordPress, PHP | Localized and deployed the regional NGO website maintaining strict corporate identity standards.",
      imageUrl: "/images/ijm1.png",
      largeImageUrl: ["/images/ijm1.png"],
      url: "https://ijmhk.org/",
    },
    {
      id: 10,
      title: "MAF Father's Day Shopify",
      subtitle:
        "JavaScript, Liquid, Shopify | Developed a customized e-commerce theme for a specific seasonal Father's Day donation campaign.",
      imageUrl: "/images/ms1.png",
      largeImageUrl: ["/images/ms1.png", "/images/ms2.png", "/images/ms3.png"],
      // url: "https://gifts.maf.org.au/pages/fathersday",
    },
    {
      id: 11,
      title: "Cadence",
      subtitle:
        "JavaScript, WordPress, PHP | Developed a corporate website managing dynamic content for company portfolios and team profiles.",
      imageUrl: "/images/c1.png",
      largeImageUrl: ["/images/c1.png"],
      url: "https://cadencemedia.com.au/",
    },
    {
      id: 12,
      title: "Finding Ruby",
      subtitle:
        "JavaScript, WordPress, PHP | Built a media-focused podcast website features optimized audio streaming posts.",
      imageUrl: "/images/fr1.png",
      largeImageUrl: ["/images/fr1.png", "/images/fr2.png", "/images/fr3.png"],
      url: "https://fightofmy.life/",
    },
    {
      id: 13,
      title: "Belvedere Dural",
      subtitle:
        "JavaScript, WordPress, PHP | Developed a premium real estate and property marketing showcase website.",
      imageUrl: "/images/b1.png",
      largeImageUrl: ["/images/b1.png"],
      url: "https://belvederedural.com.au/",
    },
    {
      id: 14,
      title: "Counsel Culture",
      subtitle:
        "WordPress, PHP | Developed a content publishing platform featuring weekly blog updates and audio podcast uploads.",
      imageUrl: "/images/cc1.png",
      largeImageUrl: ["/images/cc1.png"],
      // url: "https://counselculture.org.au/",
    },
    {
      id: 17,
      title: "Race Maf",
      subtitle:
        "React, Axios | Developed a live donation campaign application using Raisely REST API to fetch and render user metrics in real time.",
      imageUrl: "/images/race1.png",
      largeImageUrl: ["/images/race1.png"],
    },
    {
      id: 18,
      title: "Quay Park Hospital(Evolution Healthcare)",
      subtitle:
        "JavaScript, WordPress, PHP | Maintained and re-organized multi-tenant web platforms under the healthcare foundation.",
      imageUrl: "/images/q1.png",
      largeImageUrl: ["/images/q1.png"],
      url: "https://quayparksurgical.co.nz/",
    },
    {
      id: 19,
      title: "7th Avenue Sales",
      subtitle:
        "React, Node, Axios, Linux, AWS EC2 | Developed an internal company sales dashboard integrating POS APIs to display metrics, totals, and timestamps. Deployed in an AWS EC2 Linux environment.",
      imageUrl: "/images/l1.jpg",
      largeImageUrl: ["/images/l1.jpg"],
    },
    {
      id: 20,
      title: "7th Avenue",
      subtitle:
        "JavaScript | Developed a responsive commercial showcase website for a multi-location fashion retail chain.",
      imageUrl: "/images/s1.jpg",
      largeImageUrl: ["/images/s1.jpg", "/images/s2.jpg", "/images/s3.jpg"],
    },
  ],
  experience: {
    workingExperience: [
      {
        id: 1,
        year: "Mar 2021 – Present",
        position: "Web Developer",
        company: "Cadence, Sydney",
        details: [
          "- Develop and maintain responsive WordPress and client websites using JavaScript (ES6+), PHP, HTML5, and CSS3/SCSS",
          "- Integrate third-party APIs (including Salesforce) to support data flow and website functionality",
          "- Manage website content, updates, and performance improvements using WordPress and Shopify",
          "- Improve site performance and Core Web Vitals through technical SEO practices",
          "- Fix cross-browser and UI issues to ensure consistent user experience",
          "- Use GitHub for version control and team collaboration",
          "- Support lightweight scripting and automation for internal workflows",
        ],
      },
      {
        id: 3,
        year: "Feb 2018 – Feb 2021",
        position: "IT technician / Support Specialist",
        company: "7th Avenue Pty Ltd, Sydney",
        details: [
          "- Built an internal reporting dashboard using React.js, Node.js (Express), and REST APIs to visualise POS sales data for business reporting purposes",
          "- Maintained company websites and performed front-end updates using JavaScript, jQuery, and Bootstrap",
          "- Provided IT support for POS systems, hardware, and network infrastructure across store locations",
          "- Troubleshot system issues in Windows and Linux environments",
        ],
      },
      {
        id: 4,
        year: "Sep 2015 – Feb 2018",
        position: "IT administrator",
        company: "Mink Fashion Pty Ltd, Sydney",
        details: [
          "- Supported business reporting processes using SQL-based tools and data extraction",
          "- Updated e-commerce websites using HTML, CSS, JavaScript, and jQuery",
          "- Managed IT systems, user accounts, and infrastructure across Windows and Linux environments",
        ],
      },
    ],
    educationExperience: [
      {
        id: 1,
        year: "2011 - 2014",
        graduation: "Bachelor of Science in Information Technology",
        university: "University of Technology Sydney, Australia",
        details: ["- Enterprise system development", "- Sofrwate development"],
      },
      {
        id: 2,
        year: "Jun.2014 - Jul.2014",
        graduation: "Window Server, Linux Server Certificate",
        university: "Soldesk IT training centre, South Korea",
        details: ["- Linux(RHEL) ", "- Window server 2003, 2008, 2012"],
      },
      {
        id: 3,
        year: "2010",
        graduation: "Diploma of Information Technology",
        university: "Insearch, Australia",
        details: ["- Sofrwate development ", "- Networking"],
      },
    ],
  },
  blogs: [
    {
      id: 1,
      title: "Markdown & Html supported blog.",
      featuredImage: "/images/blog-image-1.jpg",
      filesource: "../../blog/markdown-html-supported-blog.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 2,
      title: "Installing NodeJS on your device.",
      featuredImage: "/images/blog-image-2.jpg",
      filesource: "../../blog/installing-nodejs-on-your-device.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 3,
      title: "UI/UX design starter with Adobe XD.",
      featuredImage: "/images/blog-image-3.jpg",
      filesource: "../../blog/uiux-design-starter-with-adobe-xd.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 4,
      title: "Boost your post for increasing sales.",
      featuredImage: "/images/blog-image-4.jpg",
      filesource: "../../blog/boost-your-post-for-increasing-sales.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 5,
      title: "Difference between GatsbyJS & NextJS.",
      featuredImage: "/images/blog-image-5.jpg",
      filesource: "../../blog/difference-between-gatsbyjs-and-nextjs.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 6,
      title: "How to choose javascript framework for project.",
      featuredImage: "/images/blog-image-6.jpg",
      filesource: "../../blog/how-to-choose-javascript-framework-for-project.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 7,
      title: "Web automation with python language.",
      featuredImage: "/images/blog-image-7.jpg",
      filesource: "../../blog/web-automation-with-python-language.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 8,
      title: "Time to use latest technology for creating a website.",
      featuredImage: "/images/blog-image-8.jpg",
      filesource: "../../blog/time-to-use-latest-technology-for-creating-a-website.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 9,
      title: "Think out of the box.",
      featuredImage: "/images/blog-image-9.jpg",
      filesource: "../../blog/think-out-of-the-box.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 10,
      title: "Trending designs in 2020.",
      featuredImage: "/images/blog-image-1.jpg",
      filesource: "../../blog/trending-designs-in-2020.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 11,
      title: "How to get 10k instagram followers?",
      featuredImage: "/images/blog-image-2.jpg",
      filesource: "../../blog/how-to-get-10k-instagram-followers.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 12,
      title: "What NodeJS can do?",
      featuredImage: "/images/blog-image-3.jpg",
      filesource: "../../blog/what-nodejs-can-do.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 13,
      title: "Futures of javascript.",
      featuredImage: "/images/blog-image-4.jpg",
      filesource: "../../blog/future-of-javascript.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 14,
      title: "Popular javascript library in 2020.",
      featuredImage: "/images/blog-image-5.jpg",
      filesource: "../../blog/popular-javascript-library-in-2020.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 15,
      title: "Promrammers must read books.",
      featuredImage: "/images/blog-image-6.jpg",
      filesource: "../../blog/programmers-must-read-books.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
  ],
  contactInfo: {
    phoneNumbers: ["+61 0430 542 144"],
    emailAddress: ["univerpark@naver.com"],
    address: "Castle Hill, NSW 2154 Australia",
  },
};

Mock.onGet("/api/information").reply((config) => {
  const response = database.information;
  return [200, response];
});

Mock.onGet("/api/services").reply((config) => {
  const response = database.services;
  return [200, response];
});

Mock.onGet("/api/references").reply((config) => {
  const response = database.references;
  return [200, response];
});

Mock.onGet("/api/reviews").reply((config) => {
  const response = database.reviews;
  return [200, response];
});

Mock.onGet("/api/skills").reply((config) => {
  const response = database.skills;
  return [200, response];
});

Mock.onGet("/api/portfolios").reply((config) => {
  const response = database.portfolios;
  return [200, response];
});

Mock.onGet("/api/experience").reply((config) => {
  const response = database.experience;
  return [200, response];
});

Mock.onGet("/api/blog").reply((config) => {
  const response = database.blogs;
  return [200, response];
});

Mock.onGet("/api/contactinfo").reply((config) => {
  const response = database.contactInfo;
  return [200, response];
});
